import { useQuery } from '@tcs/common/hooks/useQuery';
import { Account } from '@tcs/client-portal-api/types/Account';

interface Props {
  loading: boolean;
  accounts?: Account[];
  activeAccount?: Account;
}

export const useLinkedAccounts = (
  accountNumber: string,
  options?: { enabled?: boolean },
): Props => {
  const shouldFetch = options?.enabled !== false && accountNumber !== undefined;

  const { data: accounts, isLoading: linkedAccountsLoading } = useQuery<
    Account[],
    Error
  >(`/accounts/${accountNumber}/LinkedAccounts`, {
    refetchOnMount: false,
    enabled: shouldFetch,
  });

  const foundAccount = accounts?.find((a) => a.accountNumber === accountNumber);

  // if the active account is is not found in the linked accounts, we need to fall back to looking up the account alone
  // this is necessary because not every account will have records in auth linkage.
  const { data: fetchedAccount, isLoading: accountLoading } = useQuery<
    Account,
    Error
  >(`/accounts/${accountNumber}`, {
    enabled: shouldFetch && accounts != null && foundAccount === undefined,
  });

  return {
    loading: linkedAccountsLoading || accountLoading,
    accounts: accounts?.length ? accounts : [fetchedAccount],
    activeAccount: foundAccount || fetchedAccount,
  };
};

export default useLinkedAccounts;
